import { isPublic } from '@core/router/utils';
import { Auth } from '@core/auth';

import Adviser from '@/models/Adviser';

const setAdviser = async (to, from, next) => {
    if (isPublic(to)) {
        next();
    } else {
        const auth = Auth();

        if (!auth.organisation_id) {
            auth.adviser = null;
        } else if (auth.is_adviser) {
            try {
                // CP-4378 We have to get the latest adviser data to check investor_portfolio_restricted
                const adviser = await Adviser.$get(auth.organisation_id, { force: true });
                auth.adviser = adviser;
            } catch (error) {
                auth.adviser = null;
            }
        }

        next();
    }
};

export default setAdviser;
